module.exports = __webpack_public_path__ + "static/media/gullfoss.fad11072.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/generator/elements/images/gullfoss.png
// module id = 897
// module chunks = 0